import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Crown, ArrowRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

const MESSAGES = {
  comparateur: "Menus IA illimités, historique de prix complet et alertes email — tout est inclus.",
  alerts: "Recevez vos baisses de prix directement par email avec Premium.",
  default: "Débloquez toute la puissance de PanierMoinsCher.",
};

export const PremiumBanner = ({ context = "default" }) => {
  const { user, checked } = useAuth();
  const nav = useNavigate();
  if (!checked || user?.premium) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="relative flex flex-col items-start gap-4 overflow-hidden rounded-2xl border border-border bg-secondary p-6 sm:flex-row sm:items-center sm:justify-between"
      data-testid="premium-banner"
    >
      <div className="pointer-events-none absolute -right-6 -top-8 h-32 w-32 rounded-full bg-primary/20 blur-2xl" />
      <div className="relative flex items-center gap-4">
        <div className="flex h-11 w-11 flex-none items-center justify-center rounded-xl bg-accent text-white">
          <Crown className="h-6 w-6" />
        </div>
        <div>
          <p className="font-display text-lg font-800 text-white">Passez à Premium — 7 jours gratuits</p>
          <p className="text-sm text-emerald-50/80">{MESSAGES[context] || MESSAGES.default}</p>
        </div>
      </div>
      <Button onClick={() => nav("/premium")} className="relative w-full rounded-full sm:w-auto" data-testid="banner-upgrade-btn">
        Découvrir Premium <ArrowRight className="ml-2 h-4 w-4" />
      </Button>
    </motion.div>
  );
};
